import { MenuItem, Select, styled } from "@mui/material";

export const StyledSelect = styled(Select)(
  ({ theme }) => `
    width: auto;
    min-width: fit-content;
    border-radius: ${theme.spacing(10)} !important;
    
    &.Mui-focused {
      border-radius: ${theme.spacing(10)} !important;
    }
    
    &:hover {
      border-radius: ${theme.spacing(10)} !important;
    }
    
    /* Remove focus outline after selection */
    &.Mui-focused:not([aria-expanded="true"]) {
      outline: none;
    }
    
    .MuiSelect-select {
      color: ${theme.palette.dsBase.v200};
      font-family: ${theme.typography.fontFamily};
      font-size: ${theme.typography.textLg500.fontSize};
      line-height: ${theme.typography.textLg500.lineHeight};
      background-color: ${theme.palette.dsSurface.v100};
      border-radius: ${theme.spacing(10)};
      border: 1px solid ${theme.palette.dsSurface.v300};
      padding: 8px 48px 8px 16px;
      padding-right: 48px !important;
      display: flex;
      align-items: center;
      transition: all 0.2s ease-in-out;
      width: auto;
      min-width: fit-content;
      
      &:hover {
        border-color: ${theme.palette.dsSurface.v400};
      }
      
      &:focus {
        outline: none;
        border-radius: ${theme.spacing(10)};
      }

      /* Show primary focus ring only while menu is open */
      &[aria-expanded="true"] {
        border-color: ${theme.palette.primary.main};
        box-shadow: 0 0 0 2px ${theme.palette.primary.main}20;
      }
    }

    /* Ensure input padding accounts for the icon for all variants */
    & .MuiOutlinedInput-input {
      padding-right: 48px !important;
    }

    & .MuiOutlinedInput-root {
      border-radius: ${theme.spacing(10)} !important;
      
      &.Mui-focused {
        border-radius: ${theme.spacing(10)} !important;
      }
      
      &:hover {
        border-radius: ${theme.spacing(10)} !important;
      }
    }

    & .MuiOutlinedInput-notchedOutline {
      border: none;
    }

    & .MuiSelect-icon, & .MuiSelect-iconOutlined {
      right: 16px;
      color: ${theme.palette.dsNeutral.v400};
      transition: transform 0.2s ease-in-out;
    }
    
    /* Rotate icon only when expanded, based on aria-expanded on the select element */
    & .MuiSelect-select[aria-expanded="true"] ~ .MuiSelect-iconOutlined,
    & .MuiSelect-select[aria-expanded="true"] ~ .MuiSelect-icon {
      transform: rotate(180deg);
    }
`
);

export const BybVrMenuItem = styled(MenuItem)(
  ({ theme }) => `
    color: ${theme.palette.dsNeutral.v300};
    font-family: ${theme.typography.fontFamily};
    font-size: ${theme.typography.textBase600.fontSize};
    line-height: ${theme.typography.textBase600.lineHeight};
    font-weight: 600;
    padding: 8px 12px;
    margin: 2px 4px;
    border-radius: 6px;
    transition: all 0.15s ease-in-out;
    position: relative;
    padding-right: 36px;
    
    &:hover {
      background-color: ${theme.palette.dsSurface.v200};
    }
    
    &.Mui-selected {
      background-color: transparent;
      color: ${theme.palette.dsBase.v200};
      
      &:hover {
        background-color: ${theme.palette.dsSurface.v200};
      }
    }
    
    &.Mui-selected::after {
      content: '✓';
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      color: currentColor;
      font-size: 20px;
      line-height: 1;
      font-weight: bold;
    }
    
    &:focus {
      background-color: ${theme.palette.dsSurface.v200};
      outline: none;
    }
  `
);

export const BybVrMenu = styled("div")(
  ({ theme }) => `
    background-color: ${theme.palette.dsSurface.v100};
    border: 1px solid ${theme.palette.dsSurface.v300};
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding: 4px;
    margin-top: 4px;
    max-height: 200px;
    overflow-y: auto;
    
    /* Custom scrollbar */
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    
    &::-webkit-scrollbar-thumb {
      background-color: ${theme.palette.dsNeutral.v300};
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
      background-color: ${theme.palette.dsNeutral.v400};
    }
  `
);
